module.exports = __webpack_public_path__ + "static/screenie_search_1-0c1b6e072c2e511df4335faa88d7f0ba.jpg";